module.exports = __webpack_public_path__ + "static/img/038百家诚信企业活动官网.022b197.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/038百家诚信企业活动官网.jpg
// module id = 6TSz
// module chunks = 0